const styles = {
  textBold: {
    fontWeight: 'bold',
    color: 'primary.main',
  },
};

export default styles;
